<template>
 <!-- Main content -->
 <section class="content">
   <div>
     <b-alert variant="danger"
            dismissible
            :show="showDismissibleAlert"
            @dismissed="showDismissibleAlert=false">
     {{messageAlert}}
   </b-alert>
   </div>
   <!-- Main row -->
   <div class="row">
     <div class="col-md-12 col-sm-12 col-xs-12">
     </div>
   </div>
   <div class="row">
     <div class='box-body'>
        <div class='row'>
         <div class='col-md-4'  v-for="monitor in monitores" :key="monitor.id">
           <div class="box box-success">
             <div class="box-header with-border">
               <h4 class="box-title">{{monitor.nomemaquina}}</h4>
               <div class="box-tools pull-right">
                 <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i>
                 </button>
               </div>
               <!-- /.box-tools -->
             </div>
             <!-- /.box-header -->
             <div class="box-body">
                <VueSvgGauge
                  :start-angle="-110"
                  :end-angle="110"
                  :value="monitor.oee"
                  :separator-step="10"
                  :separator-thickness="1"
                  :min="0"
                  :max="100"
                  :gauge-color="[{ offset: 0, color: '#347AB0'}, { offset: 100, color: '#8CDFAD'}]"
                  :scale-interval="0.1"
                >
                </VueSvgGauge>
                <div class="info-box-marcus">
                    <h1><b>{{monitor.oee}} %</b></h1>
                </div>
                <div class="box-body">
                  <table class="table table-condensed">
                    <tr>
                      <th>Indicador</th>
                      <th>Valor</th>
                    </tr>
                    <tr>
                      <td>Disponibilidade</td>
                      <td>{{monitor.oeedisponibilidade }} %</td>
                    </tr>
                    <tr>
                      <td>Performance</td>
                      <td>{{monitor.oeeperformance }} %</td>
                    </tr>
                    <tr>
                      <td>Qualidade</td>
                      <td>{{monitor.oeequalidade }} %</td>
                    </tr>
                  </table>
                </div>
             </div>
             <!-- /.box-body -->
           </div>
           <!-- /.box -->
         </div>
       </div>
     </div>
   </div>
   <!-- /.row -->
 </section>
 <!-- /.content -->
</template>

<script>
import config from '../../config'
import VAChart from '../widgets/VAChart'
import {db} from '../../helpers/firebaseApp'

// console.log('#')
// var caminhoMonitoramento = 'sd222021/monitores'
var data = new Date()
var minutos = data.getMinutes()
if (minutos < 10) {
  minutos = '0' + minutos
}
export default {
  components: {
    'va-chart': VAChart
  },
  data () {
    return {
      dia: (data.getFullYear() + '-' + (this.adicionaZero(data.getMonth() + 1)) + '-' + this.adicionaZero(data.getDate())),
      hora: data.getHours(),
      min: minutos,
      detalhes: {
        idDetalhe: 0,
        texto: ''
      },
      paginate: ['dados'],
      dados: [],
      monitores: [],
      monitoresFirebase: null,
      errors: [],
      detalhar: false,
      showDismissibleAlert: false,
      messageAlert: '',
      deuErro: false
    }
  },
  mounted() {
    if (window.localStorage.getItem('token')) {
      this.buscarMonitorAtual()
    } else {
      this.showDismissibleAlert = true
      this.messageAlert = 'Favor efetuar o login para visualizar os dados'
      this.deuErro = true
    }
  },
  computed: {
    horaAtual() {
      let minutosAgora = data.getMinutes()
      if (minutosAgora < 10) {
        minutosAgora = '0' + minutosAgora
      }
      return minutosAgora
    }
  },
  firebase: {
    monitores: db.ref('monitores').child(config.project)
  },
  methods: {
    SegToMili: function(temposegundos) {
      return this.$moment.utc(temposegundos * 1000).format('HH:mm:ss')
    },
    ajustarData: function(data) {
      var dataAjustada = new Date(data)
      return dataAjustada.toLocaleString()
    },
    adicionaZero: function(numero) {
      if (numero <= 9) {
        return '0' + numero
      } else {
        return numero
      }
    },
    buscarMonitorAtual: function() {
      this.$store.dispatch('updateMonitorDia')
    }
  }
}
</script>
<style>
@import url('/static/js/plugins/datatables/dataTables.bootstrap.css');

table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after {
 font-family: 'FontAwesome';
}

table.dataTable thead .sorting:after {
 content: "\f0dc";
}

table.dataTable thead .sorting_asc:after {
 content: "\f0dd";
}

table.dataTable thead .sorting_desc:after {
 content: "\f0de";
}

.info-box {
 cursor: pointer;
}
.info-box-content {
 text-align: center;
 vertical-align: middle;
 display: inherit;
}
.info-box-marcus {
 text-align: center;
 vertical-align: middle;
 display: inherit;
}
.fullCanvas {
 width: 100%;
}

a {
 cursor: pointer;
}

#paginacao > li {
 display: inline-block;
 margin: 0 10px;
 text-align: center;
}

#paginacao > li.active a {
 font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// OEE.vue?62107eb9